import React from 'react';
import styled from 'styled-components';
import { Currency } from '@increasecard/typed-components';
import { localizedFullDateName, localizedFullMonthName } from '@card/commonlib';
import { CalendarEvent } from './CalendarEvent';

export const WeekTotalAmount = styled(CalendarEvent)`
  font-weight: bold;
`;

const CalendarAmount = styled(CalendarEvent)`
  border: 1px solid ${({ theme }) => theme.colorsNew.gray.subtleBorder};
`;

export interface DayAmountProps {
  day: Date;
  currency?: string;
  value: number;
  hidden?: boolean;
}

export interface WeekAmountProps {
  currency?: string;
  value: number;
  day: Date;
  week: number;
  hidden?: boolean;
}

export function DayConfirmedSalesAmount({ currency = 'ARS', day, value, hidden }: DayAmountProps) {
  return (
    <CalendarAmount
      bgColor="#DAEFF7"
      color="#0B5388"
      hidden={hidden}
      title={`Ventas confirmadas el ${localizedFullDateName(day)}`}
    >
      <Currency currency={currency} value={value} />
    </CalendarAmount>
  );
}

export function DaySalesToCollectAmount({ currency = 'ARS', day, value, hidden }: DayAmountProps) {
  return (
    <CalendarAmount
      bgColor="#1B8DC2"
      color="#FFFFFF"
      hidden={hidden}
      title={`Monto a cobrar el ${localizedFullDateName(day)}`}
    >
      <Currency currency={currency} value={value} />
    </CalendarAmount>
  );
}

export function WeekSalesToCollectAmount({
  currency = 'ARS',
  day,
  week,
  value,
  hidden
}: WeekAmountProps) {
  return (
    <WeekTotalAmount
      color="#1B8DC2"
      hidden={hidden}
      title={`Monto a cobrar la semana ${week} de ${localizedFullMonthName(day)}`}
    >
      <Currency currency={currency} value={value} />
    </WeekTotalAmount>
  );
}

export function WeekConfirmedSalesAmount({
  currency = 'ARS',
  day,
  week,
  value,
  hidden
}: WeekAmountProps) {
  return (
    <WeekTotalAmount
      color="#0B5388"
      hidden={hidden}
      title={`Ventas confirmadas de la semana ${week} de ${localizedFullMonthName(day)}`}
    >
      <Currency currency={currency} value={value} />
    </WeekTotalAmount>
  );
}
